import { createStyles, makeUiStyles } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles(() => createStyles({
  root: {
    display: '-webkit-box',
    '-webkit-line-clamp': ({ lineClamp }: { lineClamp: number }) => lineClamp,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    'line-clamp': ({ lineClamp }: { lineClamp: number }) => lineClamp,
  },
}), { name: 'TruncateText', index: StylesIndexInjections.UI_ATOMS });
